import React from 'react';
import { useDarkMode } from '../contexts/DarkModeContext';

const SellerDetailsSkeleton = () => {
  const { isDarkMode } = useDarkMode();
  return (
    <div className={`w-full max-w-full xl:w-[340px] xl:max-w-[340px] rounded-2xl shadow-lg p-5 sm:p-7 flex-shrink-0 flex flex-col justify-between border-t-[6px] border-red-500 rounded-t-2xl mx-0 animate-pulse transition-all duration-500 ${
      isDarkMode
        ? 'bg-[#2a2a2a] shadow-2xl shadow-black/50 border border-gray-700/50'
        : 'bg-white'
    }`}>
      {/* Title */}
      <div className={`h-8 rounded w-32 mb-5 ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />

      {/* Avatar and Name Section */}
      <div className="flex items-center gap-4 mb-4">
        <div className={`w-14 h-14 rounded-full ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
        <div className="flex-1">
          <div className={`h-6 rounded w-24 mb-2 ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
          <div className={`h-10 rounded w-28 ${isDarkMode ? 'bg-gray-600' : 'bg-gray-100'}`} />
        </div>
      </div>

      {/* Ratings Card */}
      <div className="mb-6">
        <div className={`rounded-2xl shadow-md px-7 py-6 text-center border ${
          isDarkMode ? 'bg-[#2a2a2a] border-gray-700/50 shadow-black/30' : 'bg-white border-gray-100'
        }`}>
          <div className={`h-6 rounded w-32 mx-auto mb-2 ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
          <div className="flex items-center justify-center gap-2 mb-1">
            <div className={`h-10 w-10 rounded-full ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <div key={i} className={`w-6 h-6 rounded ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
              ))}
            </div>
          </div>
          <div className={`h-4 rounded w-24 mx-auto ${isDarkMode ? 'bg-gray-600' : 'bg-gray-100'}`} />
        </div>
      </div>

      {/* Profile Details */}
      <div className={`h-6 rounded w-40 mb-2 ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
      <div className={`h-5 rounded w-32 mb-1 ${isDarkMode ? 'bg-gray-600' : 'bg-gray-100'}`} />
      <div className={`h-5 rounded w-36 mb-3 ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
    </div>
  );
};

export default SellerDetailsSkeleton;